// import moment from 'moment';

export default {

  created() {
  },

  computed: {
    paxEnabled() {
      return this.model.pax ? Object.keys(this.model.pax) : [];      
    },

    guestPickerPax() {
      let pax = {};
      this.paxEnabled.forEach(key => {
        pax[key] = this.model.pax[key].default;
      });

      return pax;
    },
  },

  methods: {
    onGuestPickerUpdate(val) {
      this.cartItem.pax = val;
    },
  }
}